import { isDevelopmentWithMulesoftMocks } from "@/shared/helper/environment.helper";

// This helper function is used to create a mockable function that can be swapped out for a mock implementation
// in development mode. It is used to mock API calls to MuleSoft services. The mock implementation is only used when
// we start the app in development mode with the USE_EXTERNAL_SERVICES_STUBS environment variable set to true.
export const createMockable = <TArgs extends unknown[], TResult>(options: {
  name: string;
  real: (...args: TArgs) => Promise<TResult>;
  mock?: (...args: TArgs) => Promise<TResult>;
}): ((...args: TArgs) => Promise<TResult>) => {
  if (isDevelopmentWithMulesoftMocks && options.mock) {
    // eslint-disable-next-line no-console
    console.info(`[mock] ${options.name} active`);
    return options.mock;
  }
  return options.real;
};
